import {
    TableViewStore,
    BaseListViewStore
} from 'core/stores';
import applicationContext from 'core/utils/applicationContext';
import {PatientService} from 'application/patient/services';
import { toDate } from 'core/utils';
import {ImportDetailService, ReferralService} from 'application/import/services';
import _ from 'lodash';

@applicationContext
class ImportPatientDuplicatesViewStore extends BaseListViewStore {
    constructor(rootStore) {

        const service = new PatientService(rootStore.application.baasic.apiClient);
        const detailService =  new ImportDetailService(rootStore.application.baasic.apiClient);
        const referralService = new ReferralService(rootStore.application.baasic.apiClient);
        const firstName = rootStore.routerStore.routerState.params.firstName;
        const lastName = rootStore.routerStore.routerState.params.lastName;
        const importHeaderId = rootStore.routerStore.routerState.params.importHeaderId;
        const patientGroupId = rootStore.routerStore.routerState.params.patientGroupId;

        super(rootStore, {
            name: 'duplicates',
            autoInit: true,
            routes: {
                edit : async (resource) => {
                    resource = {
                        importHeaderId: importHeaderId,
                        patientGroupId: patientGroupId,
                        patientId: resource.brightreeID
                    };

                    this.tableStore.loaderStore.suspend();
                    try {
                        await detailService.usePatient(resource);
                        if(this.rootStore.routerStore.routeHistory.length > 1){
                            this.rootStore.routerStore.goBack();
                        }else{
                            this.rootStore.routerStore.goTo('master.app.main.import.detail.list', { id: importHeaderId });                                            
                        }
                        this.rootStore.notificationStore.success("Patient successfully saved.");
                    }
                    catch(err) {
                        this.rootStore.notificationStore.error(err && err.data ? err.data : 
                            "Error occured while trying to save the patient.");
                    }
                    this.tableStore.loaderStore.resume();

                }
            },
            actions: () => {
                return {
                    find: async (params) => {
                        const response = await service.findPatients(_.extend(params, {firstName : firstName, lastName: lastName}));
                        const res = _.extend(response,
                            {
                                item: _.map(response.item, item => {
                                    return _.extend(
                                        item, {
                                            dateOfBirth: toDate(item.patientGeneralInfo.birthDate),
                                            firstName: item.patientGeneralInfo.name.first,
                                            lastName: item.patientGeneralInfo.name.last,
                                            facility: item.patientGeneralInfo.facility && item.patientGeneralInfo.facility.value,
                                            ssn: item.patientGeneralInfo.ssn
                                        }
                                    );
                                })
                            });
                        return res.item;
                    }
                }
            }
        });

        this.invalidateRefrerrals = async () => {
            this.tableStore.loaderStore.suspend();
            try {
                await referralService.invalidate();  
                this.rootStore.notificationStore.success("Referral list successfully refreshed.");                       
            }
            catch(err) {
                this.rootStore.notificationStore.error("Error occured on while trying to refresh Referral list.");
            }
            this.tableStore.loaderStore.resume();            
        };

        this.setTableStore(new TableViewStore(this.queryUtility, {
            columns: [
                {
                    key: 'lastName',
                    title: 'PATIENT.LIST.COLUMNS.LAST_NAME',
                    disableClick: true
                },
                {
                    key: 'firstName',
                    title: 'PATIENT.LIST.COLUMNS.FIRST_NAME'
                },
                {
                    key: 'dateOfBirth',
                    title: 'PATIENT.LIST.COLUMNS.DATE_OF_BIRTH'
                },
                {
                    key: 'ssn',
                    title: 'PATIENT.LIST.COLUMNS.SSN'
                },
                {
                    key: 'facility',
                    title: 'PATIENT.LIST.COLUMNS.FACILITY'
                }
            ],
             actions: {
                onEdit: (resource) => this.routes.edit(resource)
             }
        }));
    }
}

export default ImportPatientDuplicatesViewStore;
